<template>
  <div
    class="submitMessage"
    :class="{
      'submitMessage-success': status === 'success',
      'submitMessage-error': status === 'error'
    }"
    v-show="message"
  >
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'submitMessage',
  props: {
    status: { String, required: true },
    message: { String, default: '' }
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/SubmitMessage.vue